import UIkit from 'uikit/dist/js/uikit-core';
import initHeaderLanguage from './theme/headerLanguage';
import initVideoProgress from './theme/videoProgress';
import initRegionsAndRoles from './theme/regionsAndRoles';
import initRegionsAndRolesV2 from './theme/regionsAndRolesV2';
import initIconCardsV2 from './theme/iconCardsV2';
import initLearningPlans from './theme/learningPlans';
import initCopyPassword from './theme/copyPassword';
import initCapabilityProfiles from './theme/capabilityProfiles';
import initBookmarkPage from './theme/bookmarkPage';
import initModalCookie from './theme/modalCookie';

// Bundling UIkit takes its UMD CommonJS branch, which never reaches window, so
// the global the theme's modules call has to be set here.
window.UIkit = UIkit;

initHeaderLanguage();
initVideoProgress();
initRegionsAndRoles();
initRegionsAndRolesV2();
initIconCardsV2();
initLearningPlans();
initCopyPassword();
initCapabilityProfiles();
initBookmarkPage();
initModalCookie();
